export default {"src":"/_next/static/media/Telegram.5b1dccd6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};